export default class GeneralValidator {
    constructor() {
        this.errors = {};
    }

    required(value) {
        if (!value || value === "") {
            this.errors.required = "This field is required";
            return false;
        }
        return true;
    }

    regex(value, { pattern, message }) {
        if(value === "") return true
        
        if (!new RegExp(pattern).test(value)) {
            this.errors.regex = message;
            return false;
        }
        return true;
    }

    minLength(value, length) {
        if (value.length < length) {
            this.errors.minLength = `This field must be at least ${length} characters long`;
            return false;
        }
        return true;
    }

    maxLength(value, length) {
        if (value.length > length) {
            this.errors.maxLength = `This field must be at most ${length} characters long`;
            return false;
        }
        return true;
    }

    // This function named validateRequiredFields validates required fields in an object. It checks if the field value is an object, and if it is required and not filled, or if it has any errors. If there are no errors and all required fields are filled, it returns false.
    static validateRequiredFields(fields) {
        let hasErrors = false;
        for (let field in fields) {

            // Check if the value is an object
            if (typeof fields[field] !== "object") continue;

            // Check if the field is required and not filled
            if (
                fields[field]?.rules &&
                fields[field]?.rules.required == true &&
                !fields[field]?.value
            ) {
                hasErrors = true;
            }

            // Check if the field has any errors
            if (fields[field]?.errors && Object.keys(fields[field].errors).length > 0) {
                hasErrors = true;
            }
        }

        // Return false if there are no errors and all required fields are filled
        return hasErrors;
    }


    validate(value, validationRules) {
        this.errors = {};

        for (let rule in validationRules) {
            if (validationRules.hasOwnProperty(rule)) {
                const ruleValue = validationRules[rule];
                if (rule === "required" && ruleValue) {
                    this.required(value);
                } else if (rule === "regex" && ruleValue) {
                    this.regex(value, ruleValue);
                } else if (rule === "minLength" && value.length && ruleValue) {
                    this.minLength(value, ruleValue);
                } else if (rule === "maxLength" && value.length && ruleValue) {
                    this.maxLength(value, ruleValue);
                }
            }
        }

        return this.errors;
    }

    validateAllFieldsRules(fieldsObj, updateFieldsCb) {
        let isErrorFree = true;
        let errorObject = {};

        const fields = { ...fieldsObj }

        for (let field in fields) {
            if (typeof fields[field] !== "object") continue;

            const { rules, value } = fields[field];
            if (rules, value) {
                const fieldErrors = this.validate(value, rules)
                if (Object.keys(fieldErrors).length) {
                    isErrorFree = false;
                    errorObject = { ...errorObject, [field]: { ...fields[field], errors: fieldErrors } }
                }
            }
        }

        updateFieldsCb({ ...fields, ...errorObject })
        return isErrorFree;
    }
}

export const generalValidator = new GeneralValidator();

